import Index from '@/views/players/Index'
import Create from '@/views/players/Create'
import Merge from '@/views/players/Merge.vue'
import Duplicates from '@/views/players/Duplicates.vue'
import Edit from '@/views/players/Edit'
import Tags from '@/views/players/Tags.vue'

export default [
  {
    path: ':clientId/players',
    name: 'players.index',
    component: Index
  },
  {
    path: ':clientId/players/tags',
    name: 'players.tags',
    component: Tags,
    meta: {
      title: 'Player Tags',
      breadcrumb: [
        {
          name: 'Players',
          route: {
            name: 'players.index'
          }
        },
        {
          name: 'Tags'
        }
      ]
    }
  },
  {
    path: ':clientId/players/create',
    name: 'players.create',
    component: Create,
    meta: {
      title: 'Create player',
      breadcrumb: [
        {
          name: 'Players',
          route: {
            name: 'players.index'
          }
        },
        {
          name: 'Create'
        }
      ]
    }
  },
  {
    path: ':clientId/players/merge',
    name: 'players.merge',
    component: Merge,
    meta: {
      title: 'Merge player',
      breadcrumb: [
        {
          name: 'Players',
          route: {
            name: 'players.merge'
          }
        },
        {
          name: 'Merge'
        }
      ]
    }
  },
  {
    path: ':clientId/players/duplicates',
    name: 'players.duplicates',
    component: Duplicates,
    meta: {
      title: 'Duplicate players',
      breadcrumb: [
        {
          name: 'Players',
          route: {
            name: 'players.index'
          }
        },
        {
          name: 'Duplicates'
        }
      ]
    }
  },
  {
    path: ':clientId/players/:uuid',
    name: 'players.edit',
    component: Edit,
    meta: {
      title: 'Edit player',
      breadcrumb: [
        {
          name: 'Players',
          route: {
            name: 'players.index'
          }
        },
        {
          name: 'Edit'
        }
      ]
    }
  }
]
